/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateCustomerDto,
  CustomerResponse,
  RentEquipmentResponse,
  SetRentEquipmentsDto,
  UpdateCustomerDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Customers<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags customers
   * @name Create
   * @request POST:/customers
   * @secure
   */
  create = (data: CreateCustomerDto, params: RequestParams = {}) =>
    this.request<CustomerResponse, any>({
      path: `/customers`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name FindAll
   * @request GET:/customers
   * @secure
   */
  findAll = (
    query: {
      page: number;
      perPage: number;
      search?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CustomerResponse[], any>({
      path: `/customers`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name FindAllCustomersNoPagination
   * @request GET:/customers/no-pagination
   * @secure
   */
  findAllCustomersNoPagination = (params: RequestParams = {}) =>
    this.request<CustomerResponse[], any>({
      path: `/customers/no-pagination`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name FindOne
   * @request GET:/customers/{id}
   * @secure
   */
  findOne = (id: string, params: RequestParams = {}) =>
    this.request<CustomerResponse, any>({
      path: `/customers/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name Update
   * @request PATCH:/customers/{id}
   * @secure
   */
  update = (id: string, data: UpdateCustomerDto, params: RequestParams = {}) =>
    this.request<CustomerResponse, any>({
      path: `/customers/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name DeleteCustomer
   * @request DELETE:/customers/{id}
   * @secure
   */
  deleteCustomer = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/customers/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name GetRentEquipments
   * @request GET:/customers/{id}/rent-equipments
   * @secure
   */
  getRentEquipments = (id: string, params: RequestParams = {}) =>
    this.request<RentEquipmentResponse[], any>({
      path: `/customers/${id}/rent-equipments`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags customers
   * @name SetRentEquipments
   * @request PUT:/customers/{id}/rent-equipments
   * @secure
   */
  setRentEquipments = (
    id: string,
    data: SetRentEquipmentsDto,
    params: RequestParams = {},
  ) =>
    this.request<RentEquipmentResponse[], any>({
      path: `/customers/${id}/rent-equipments`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
